import React from "react";
import Style from "../style/bussiness.module.scss";
const BussinessImg = "/img/bussiness.jpg";

const Bussiness = () => {
  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div className={Style.divide}>
          <div className={Style.image}>
            <img
              src={BussinessImg}
              alt="Digital"
              loading="lazy"
              width="100%"
              height="100%"
            />
          </div>
          <div className={Style.content}>
            <h2>
              Reach Local Customers and Boost Your Business's{" "}
              <span>
                Visibility!<i></i>
              </span>
            </h2>
            <p>
              Make it easier for customers to discover you by promoting your
              business here.
            </p>
            <a href="/marketing-solutions">Marketing Solutions</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bussiness;
